export var AniConditionType;
(function (AniConditionType) {
    AniConditionType[AniConditionType["Greater"] = 0] = "Greater";
    AniConditionType[AniConditionType["Less"] = 1] = "Less";
    AniConditionType[AniConditionType["Equals"] = 2] = "Equals";
    AniConditionType[AniConditionType["NotEqual"] = 3] = "NotEqual";
})(AniConditionType || (AniConditionType = {}));
export class Animation2DCondition {
}
